export const PRODUCT_SERVICE_ENDPOINT = {
  CATALOG_PUBLISHABLE_TENANTS: '/catalog/publishableTenants',
  CATALOG_WORFLOW: '/catalog/workflow'
};
